import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from '../traitement-data/traitement-data.component';
import { FuitesPipe } from '../../../pipes/fuites.pipe';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';
import { FuitesStatutPipe } from '../../../pipes/fuites-statut.pipe';

@Component({
  selector: 'app-traitement-data-fuites',
  standalone: true,
  imports: [
    TraitementDataComponent,
    FuitesPipe,
    FuitesStatutPipe,
    ALaDateDuPipe
  ],
  templateUrl: './traitement-data-fuites.component.html',
  styleUrl: './traitement-data-fuites.component.scss',
})
export class TraitementDataFuitesComponent {
  @Input() patient: Patient | undefined;
}
